// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { toggleSecondModalClose } from '../../storage/actions/modalsActions';
import Notification from '../notification';

const ConfirmModal = ({
  toggleSecondModalClose,
  modalState,
}) => {
  const [value, setValue] = useState('');

  const handlerChanges = (event) => setValue(event?.target?.value);

  const onClose = () => {
    toggleSecondModalClose('confirmModal', true);
  };

  // eslint-disable-next-line consistent-return
  const onSubmit = () => {
    if (modalState.type?.inputLabel && !value) {
      return Notification('warning', {
        message: `Type ${modalState.type?.inputLabel}!`,
      });
    }
    modalState.type.onAccept(value);
    onClose();
  };

  const onReject = () => {
    modalState.type.onReject();
    onClose();
  };

  if (!modalState.isOpen) return null;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title">
            {modalState?.type?.header || 'Are You Sure?'}
          </div>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="modal_body">
          {modalState.type?.content && (
            <div className="modal_content">
              {modalState.type?.content}
            </div>
          )}

          {modalState.type?.inputLabel && (
            <div className="field_col">
              <label className="field_name" htmlFor="confirm_modal_value">
                {modalState.type?.inputLabel}
              </label>
              <div className="field_block">
                <input
                  id="confirm_modal_value"
                  className="form-control dashboard-input"
                  type="text"
                  value={value}
                  onChange={handlerChanges}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') onSubmit();
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--secondary"
            onClick={modalState.type?.onReject ? onReject : onClose}
          >
            {modalState?.type?.buttonLabels?.reject || 'No'}
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            onClick={onSubmit}
          >
            {modalState?.type?.buttonLabels?.confirm || 'Yes'}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.confirmModal,
});

export default connect(mapStateToProps, { toggleSecondModalClose })(ConfirmModal);
